import React from 'react';
import { Box, Button, Collapse, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CODE_BOX_SX, CODE_PRE_SX } from '../layoutSx';

/** Collapsible SQL in its own scrolling box (never widens its container). */
export default function LastSql({ sql, defaultOpen = false, maxHeight = 220 }) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(defaultOpen);
  if (!sql) return null;
  return (
    <Box sx={{ minWidth: 0, maxWidth: '100%' }}>
      <Button size="small" onClick={() => setOpen((o) => !o)} sx={{ textTransform: 'none', px: 0.5, minWidth: 0 }}
        aria-expanded={open}>
        {open ? t('Dashboards.repair.hideSql') : t('Dashboards.repair.showSql')}
      </Button>
      <Collapse in={open} unmountOnExit>
        <Box sx={{ ...CODE_BOX_SX, maxHeight, overflowY: 'auto' }}>
          <Typography component="pre" variant="caption" sx={CODE_PRE_SX} data-testid="last-sql">{sql}</Typography>
        </Box>
      </Collapse>
    </Box>
  );
}
